import { configureStore } from "@reduxjs/toolkit";
import { backendApi } from "./services/backendApi";
import userReducer from "./slices/user/userSlice";
import partnerReducer from "./slices/partner/partnerSlice";
import rolesReducer from "./slices/roles/rolesSlice";
import mdmImportReducer from "./slices/mdmImport/mdmImportSlice";

export const store = configureStore({
  reducer: {
    // Backend API (handles real backend endpoints, includes GSAP Volumes API)
    [backendApi.reducerPath]: backendApi.reducer,
    // Regular slices
    user: userReducer,
    partner: partnerReducer,
    roles: rolesReducer,
    mdmImport: mdmImportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(backendApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
